import React from "react"

class Subscription extends React.Component {

  render() {


    return (
      <>
      <a href="http://docs.google.com/forms/d/e/1FAIpQLSfTnwZA5NungZ4MP6pfkmpezHpS7qyGFf7_zhdOCRMyY2YWsA/viewform" target="_blank" rel="noopener noreferrer">
         <button className="subscription">
              S'inscrire
         </button>
      </a>
      </>
                
    );
  }
}


export default Subscription;
